import type { FaireProductEntity } from "../../entity_types/product";

export const p_3pzgfksp47: FaireProductEntity = {
  token: "p_3pzgfksp47",
  type: "product",
  name: "Goldfish Charm, Sealife charm,exotic Fish charm CPG2376",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/4be3dc8dd1b105193922e81ca01124cc2d22f5d550b60426caddad61e34d4588.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28bffc1157b3884ca804bd838bd886b217919cacf93bd806e0929038a1e02eb1.jpeg",
    "https://cdn.faire.com/fastly/4619bc96c5c715866955c2817bb22006a59b9c80677e97cdcd33a97193b41cc4.jpeg",
    "https://cdn.faire.com/fastly/3f503e8fc9081ea6afbea05fc4c1bdd7bdbeed8b49cb0c65534d59fdb0424b27.jpeg",
    "https://cdn.faire.com/fastly/562e6ef17f20964ef0e7f6450cb9f1dbb8b79e1f4012388aa7ffeea1e64b7813.jpeg",
    "https://cdn.faire.com/fastly/eb4870a9091b51d56236c4ef4dc47d57db98d002baed662ad14c0552acbe1ec8.jpeg",
    "https://cdn.faire.com/fastly/4d4feb3e0399c772ce37ae8f5d013ea7598fd29245acb3aaeb9c7fb5697313db.jpeg",
    "https://cdn.faire.com/fastly/a968674485912fc5263e5fa2a488e5baba5ee9a8718af7be72ac3b0f2c4e82d2.jpeg",
    "https://cdn.faire.com/fastly/fd29be14b37b85549bf1edd13e81223cbdcd6067de519b6c577a9c3134f9d3ea.jpeg",
    "https://cdn.faire.com/fastly/b0fc7161d5123bd670fe7a8e5996671c1b32e8da5c513ae19245410b66821f90.jpeg",
    "https://cdn.faire.com/fastly/95edd429cbecc023d0c6356a6ae81a355d240d1c37eac624ce4cf9ebf8404366.jpeg",
  ],
  priceDollars: 5.51,
  description:
    "Gold Colorful Fish Charm,High Polished Shiny with Enamel finish, Good For Necklace, Earrings CPG2376\nListing Is For One Single Piece.\nChain is not included in these sales\n\n14K Gold Plating Over Brass With Enamel\nMeasurements: 10.1mm x 26.7mm\nThickness:9.6mm\nRing Size:1.5mm\nAll Measurements Are Approximate\nLead, Cadmium and nickel free\nQuantity discount available at drop down menu\nShips From Los Angeles",
  tags: [],
  msrpDollars: 11.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:58.613Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
